import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemEntity } from './item.entity';

@Index('fk_item__id', ['fkItemId'], {})
@Entity('item_dea_schedule')
export class ItemDeaScheduleEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_item__id',
		nullable: false,
		unsigned: true,
	})
	public fkItemId!: number;

	@Column('varchar', { name: 'licenseLevel', nullable: true, length: 20 })
	public licenseLevel!: string | null;

	@Column('varchar', { name: 'state', nullable: true, length: 2 })
	public state!: string | null;

	@Column('varchar', { name: 'schedule', nullable: true, length: 10 })
	public schedule!: string | null;

	@ManyToOne(() => ItemEntity, (item) => item.itemDeaSchedules, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;
}
